import React from 'react';
import { Helmet } from 'react-helmet';
import { FaLightbulb, FaMicroscope } from 'react-icons/fa';
import {
  ServicesContainer,
  ServicesHero,
  ServicesContent,
  ServicesTitle,
  ServicesSubtitle,
  ServicesGrid,
  ServiceCard,
  ServiceIcon,
  ServiceTitle,
  ServiceDescription,
  ServiceDetails,
  ServiceDetailItem,
  ServiceDetailTitle,
  ServiceDetailText,
  ContactSection,
  ContactContent,
  ContactTitle,
  ContactText,
  ContactButton
} from './styles';

const ServicesPage = () => {
  return (
    <ServicesContainer>
      <Helmet>
        <title>Services - Core Plasma</title>
        <meta name="description" content="Core Plasma offers Technology Licensing and Plasma Consulting services to help accelerate R&D and solve complex plasma technology challenges." />
      </Helmet>

      <ServicesHero>
        <ServicesContent>
          <ServicesTitle>Our Services</ServicesTitle>
          <ServicesSubtitle>
            Leveraging decades of expertise to accelerate your R&D and solve complex plasma technology challenges
          </ServicesSubtitle>
        </ServicesContent>
      </ServicesHero>

      <ServicesGrid>
        <ServiceCard>
          <ServiceIcon>
            <FaMicroscope size={40} />
          </ServiceIcon>
          <ServiceTitle>Technology Licensing</ServiceTitle>
          <ServiceDescription>
            Accelerate your product development with plasma technologies
          </ServiceDescription>
          <ServiceDetails>
            <ServiceDetailItem>
              <ServiceDetailTitle>Comprehensive Expertise</ServiceDetailTitle>
              <ServiceDetailText>
                Utilize a wide spread of technologies, utilizing Dr. Yi's expertise to accelerate your product development
              </ServiceDetailText>
            </ServiceDetailItem>
            <ServiceDetailItem>
              <ServiceDetailTitle>Expert Support</ServiceDetailTitle>
              <ServiceDetailText>
                Partnering with Core Plasma is more than just a license agreement. We are here to help you every step of the way with Dr. Won Yi's decades of experience in the plasma field.
              </ServiceDetailText>
            </ServiceDetailItem>
            <ServiceDetailItem>
              <ServiceDetailTitle>Accelerated Development</ServiceDetailTitle>
              <ServiceDetailText>
                Want to implement plasma into your next generation of products? Save time and resources in your buy, build, partner strategy by leveraging decades of expertise.
              </ServiceDetailText>
            </ServiceDetailItem>
          </ServiceDetails>
        </ServiceCard>

        <ServiceCard>
          <ServiceIcon>
            <FaLightbulb size={40} />
          </ServiceIcon>
          <ServiceTitle>Plasma Consulting</ServiceTitle>
          <ServiceDescription>
            Get expert guidance on plasma-related technological challenges
          </ServiceDescription>
          <ServiceDetails>
            <ServiceDetailItem>
              <ServiceDetailTitle>Technical Expertise</ServiceDetailTitle>
              <ServiceDetailText>
                By working with Core Plasma, you can save valuable time and resources by leveraging Dr. Yi's decades of experience in plasma physics and engineering to solve your complex plasma technology challenges. 
              </ServiceDetailText>
            </ServiceDetailItem>
            <ServiceDetailItem>
              <ServiceDetailTitle>Problem Solving</ServiceDetailTitle>
              <ServiceDetailText>
                Having difficulties in your R&D process? We are here to help! Book a call to discuss your challenges, and we can help create a plan of attack for your team.
              </ServiceDetailText>
            </ServiceDetailItem>
            <ServiceDetailItem>
              <ServiceDetailTitle>Optimization</ServiceDetailTitle>
              <ServiceDetailText>
                Whether your team is having trouble with ozone overproduction, downsizing, having difficulty with scaling, or any other technical issues, we have the experience needed to help.
              </ServiceDetailText>
            </ServiceDetailItem>
          </ServiceDetails>
        </ServiceCard>
      </ServicesGrid>

      <ContactSection>
        <ContactContent>
          <ContactTitle>Ready to Get Started?</ContactTitle>
          <ContactText>
            Contact us to discuss how our services can help accelerate your plasma technology development
          </ContactText>
          <ContactButton to="/contact">Contact Us</ContactButton>
        </ContactContent>
      </ContactSection>
    </ServicesContainer>
  );
};

export default ServicesPage; 